import { useEffect, useRef } from 'react';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import EditComponent from './MembershipForShopBalanceEdit';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';

const WebComponent = (props: any) => {
    const title = '会员店铺余额';
    const ref = useRef<any>(undefined);
    const { closeModal, data } = props;

    useEffect(() => {

    }, []);

    //表头
    const columnsHead = [
        {
            title: '店铺',
            dataIndex: 'shop',
            render: (val: any) => val?.shopName
        },
        {
            title: '会员',
            dataIndex: 'membershipInfo',
            render: (val: any) => val?.membershipName
        },
        {
            title: '余额',
            dataIndex: 'balance'
        },
        {
            title: '赠送',
            dataIndex: 'gifts'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: title,
        apiId: 'membershipForShopBalance',
        columns,
        EditComponent,
        serviceId: 'business',
        sendPageData: data,
        showStates: true
    };

    return (
        <>
            <AntDraggableModal
                title={title}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={closeModal}
                closable={false}
                maskClosable={false}
                width={800} >
                <WebUniversal props={extendProps} ref={ref} />
            </AntDraggableModal>
        </>
    )
}

export default WebComponent;
